<template>
  <nuttrema-layout-west-slide width="25%" minWidth="35em" >
    <west-slide-left-navigation slot="navigation-top">
      <router-link
         tag="a" activeClass="is-active" exact
        :title="$t('label.cancel')"
        :to="{ name: _get(meta, 'navigation.cancel') }">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </router-link>
    </west-slide-left-navigation>
    <!-- end ~ navigation-top -->
    <images-upload
      :meta="meta"
      :StuffToEatImages="StuffToEatImages"
      @cancel="onCancelEvent"
      @uploadImage="onUploadImage">
    </images-upload>
  </nuttrema-layout-west-slide>
</template>

<script>
import { mapActions } from 'vuex';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';
import PageProps from 'components/mixins/page-props';

import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import ImagesUpload from './cmpt-images-upload';

export default {
  name: 'page-images-upload',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: true,
      default: null,
    },
    productType: {
      required: true,
      default: null,
    },
    meta: {
      required: false,
      default: null,
    },
  },
  components: {
    ImagesUpload,
    NuttremaLayoutWestSlide,
    WestSlideLeftNavigation,
    NuttremaIconicaSidebarLink,
  },
  computed: {
    StuffToEatImages() {
      return this.$store.getters.StuffToEatImages(this.id);
    },
  },
  methods: {
    // should be overwriten
    ...mapActions({
      UploadImage: '',
    }),
    onUploadImage(images) {
      this.UploadImage({
        id: this.id,
        type: this.productType,
        images,
      }).then(() => {
        this.successNotification({ label: 'label.images' });
        this.onSuccessEvent();
      }).catch(() => {
        this.errorNotification();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/images/page-images-upload.vue